import React from "react";

const Warning = ({ fill, width, color, style }) => (
  <svg
    style={style}
    width={width}
    height={width}
    viewBox="0 0 53 53"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M52.8608 3.59378C44.2707 1.12504 35.3678 -0.0839757 26.4304 0.00452924C17.493 -0.0839757 8.59011 1.12504 0 3.59378L0 49.2823C8.59011 51.751 17.493 52.96 26.4304 52.8715C35.3678 52.96 44.2707 51.751 52.8608 49.2823V3.59378Z"
      fill={fill}
    />
    <path
      d="M26.7882 30.149C25.8545 30.149 25.1118 30.8068 25.1118 31.7193C25.1118 32.6318 25.8545 33.332 26.7882 33.332C27.7431 33.332 28.4646 32.6318 28.4646 31.7193C28.4646 30.8068 27.7431 30.149 26.7882 30.149ZM28.1463 18.4354L25.4089 18.4354L25.4089 28.897L28.1463 28.3241L28.1463 18.4354Z"
      fill={color}
    />
    <circle
      cx="26.8594"
      cy="26"
      r="14.0441"
      stroke={color}
      strokeWidth="3.91176"
    />
  </svg>
);

Warning.defaultProps = {
  width: 8,
  fill: "black",
  color: "white",
};

export default Warning;
